import { render, staticRenderFns } from "./UserHost.vue?vue&type=template&id=5a66661b&scoped=true&"
import script from "./UserHost.vue?vue&type=script&lang=js&"
export * from "./UserHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a66661b",
  null
  
)

export default component.exports